import { canv } from "@/canv/global";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeStar extends Shape {
    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = height / 2 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 1.75 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + w / 2, y); // центр верха
        canv.ctx.lineTo(x + w * 0.667, y + h * 0.333);
        canv.ctx.lineTo(x + w, y + h * 0.375);
        canv.ctx.lineTo(x + w * 0.75, y + h * 0.625);
        canv.ctx.lineTo(x + w * 0.834, y + h);
        canv.ctx.lineTo(x + w * 0.5, y + h * 0.8);
        canv.ctx.lineTo(x + w * 0.166, y + h);
        canv.ctx.lineTo(x + w * 0.25, y + h * 0.625);
        canv.ctx.lineTo(x, y + h * 0.375);
        canv.ctx.lineTo(x + w * 0.333, y + h * 0.333);
        canv.ctx.lineTo(x + w / 2, y);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="none" viewBox="0 0 24 24">
                <path
                    fill="${fill}"
                    stroke="${stroke}"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 19.24 4.9 23l1.36-7.96L.5 9.4l7.95-1.16L12 1l3.55 7.24L23.5 9.4l-5.76 5.64L19.1 23 12 19.24Z"
                />
            </svg>
        `;
    }
}
